module.exports = __webpack_public_path__ + "images/menu-dashboard-sel.svg?b252fee73edbe9877f76b420852197ee";